// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/payrolls",
  ViewPayslip: "/pyr/view-payslip",
  SendPayslip: "/pyr/send-payslip",
  BankTransfer: "/pyr/payrolls/bank-transfer",
  PayslipLog: "/pyr/payslip-log",
  ListTemplatePayslip: "/pyr/payslips",
  ApprovalStatus: "/pyr/payrolls/approval-status",
  CheckPayslipReadiness: "/pyr/payslip/check-readiness",
  GeneratePayslipFile: "/pyr/payslip/generate-file",
};
